<template>
  <div class="edit">
    <el-form
      :model="editForm"
      ref="batchForm"
      :rules="editRules"
      label-width="160px"
      size="small"
      style="width: 600px"
    >
      <el-form-item label="安装费用:" prop="installFee">
        <el-input
          v-model="editForm.installFee"
          placeholder="请输入安装费用"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注:" prop="remarks">
        <el-input
          v-model="editForm.remarks"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          maxlength="500"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { validateNumber } from "@/utils/index";
export default {
  props: {
    currentData: {
      type: Object,
      default: () => ({}),
    },
    selectionData: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    currentData: {
      handler(newVal) {
        this.editForm.installFee = newVal.installFee || "";
        this.editForm.remarks = newVal.remarks || "";
      },
      immediate: true,
    },
  },
  data() {
    return {
      editForm: {
        installFee: "",
        remarks: "",
      },
      editRules: {
        installFee: [
          { required: true, message: "请输入安装费用", trigger: "blur" },
          { validator: validateNumber, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 提交表单
    editSubmit() {
      this.$refs.batchForm.validate((valid) => {
        if (valid) {
            this.axios({
            method: "post",
            url: `/pending-settlement-order/edit/${this.currentData.id}`,
            data: {
                id: this.currentData.id,
                installFee: this.editForm.installFee,
                settlementRemarks: this.editForm.remarks,
            },
          }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: "编辑成功",
                type: "success",
              });
             this.$emit("editSuccess");
            } else {
              this.$message({
                message: res.data.message,
                type: "error",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    bacthSubmit(){
      this.$refs.batchForm.validate((valid) => {
        if (valid) {
          const list = this.selectionData.map((item) => {
            return {
              id: item.id,
              installFee: this.editForm.installFee,
              settlementRemarks: this.editForm.remarks,
            };
          });
          this.axios({
            method: "post",
            url: `/pending-settlement-order/edit/batch`,
            data: list,
          }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: res.data.message,
                type: "success",
              });
              this.$emit("editSuccess");
            } else {
              this.$message({
                message: res.data.message,
                type: "error",
              });
            }
          });
        } else {
          return false;
        }
      });
    }
  },
};
</script>

<style scoped>
.edit {
  margin-top: 20px;
}
</style>